import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { meetingReducer } from './meeting-creator/reducers';
export function createRootReducer(history) {
    return combineReducers({
        router: connectRouter(history),
        meeting: meetingReducer
    });
}
